<template>
    <b-row>
        <b-col sm="12" md="3" lg="3">
            <div class="p-3 text-center">
                <b-avatar class="m-3" size="6rem"/>
                <p class="text-bold">{{ subscriptor.email }}</p>
            </div>
            <b-list-group>
                <b-list-group-item>
                    <b>ID:</b> {{ subscriptor.id }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Nombre:</b> {{ subscriptor.nombre }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Apellidos:</b> {{ subscriptor.apellidos }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Pais:</b> {{ subscriptor.pais }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Provincia:</b> {{ subscriptor.provincia }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Localidad:</b> {{ subscriptor.localidad }}
                </b-list-group-item>
                <b-list-group-item>
                    <b>Estado: </b> <b-badge :variant="subscriptor.activo ? 'success' : 'secondary'">{{ subscriptor.activo ? 'Activo' : 'Desactivado' }}</b-badge>
                </b-list-group-item>
            </b-list-group>
        </b-col>
        <b-col sm="12" md="9" lg="9">
            <b-tabs fill pills>
                <b-tab title="General" active>
                    <b-row class="pt-3">
                        <b-col sm="12" md="4" lg="4">
                            <b-card>
                                <b-card-text class="text-center">
                                    <h1>{{ subscriptor.total_emails_enviados }}</h1>
                                    <p>Emails enviados</p>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col sm="12" md="4" lg="4">
                            <b-card>
                                <b-card-text class="text-center">
                                    <h1>{{ subscriptor.total_visulizaciones }}</h1>
                                    <p>Visualizaciones</p>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col sm="12" md="4" lg="4">
                            <b-card>
                                <b-card-text class="text-center">
                                    <h1>{{ subscriptor.total_emails_clicados }}</h1>
                                    <p>Clics</p>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col cols=12 class="pt-3">
                            <h4>Últimos eventos:</h4>
                            <hr/>
                            <TimeLineComponent
                                :events="subscriptor.actividades_recientes.map(evento => ({
                                    id: evento.id,
                                    icon: getIcon(evento.tipo_actividad),
                                    date: evento.created_at,
                                    title: getTitle(evento.tipo_actividad),
                                    message: getMessage(evento)
                                }))"
                            />
                        </b-col>
                    </b-row>
                </b-tab>
                <b-tab title="Emails enviados">
                    <EmailsEnviados
                        :subscriptor="subscriptor"
                    />                 
                </b-tab>
                <b-tab title="Visualizaciones">
                    <EmailsVisualizaciones
                        :subscriptor="subscriptor"
                    />
                </b-tab>
                <b-tab title="Clics">
                    <EmailsClicks
                        :subscriptor="subscriptor"
                    />
                </b-tab>
            </b-tabs>
        </b-col>
    </b-row>
</template>

<script>
    import EmailsEnviados from '@/components/backend/campana-emails/subscriptores/detalle/EmailsEnviados';
    import TimeLineComponent from '@/components/common/TimeLineComponent.vue';
    import EmailsVisualizaciones from '../EmailsVisualizaciones.vue';
    import EmailsClicks from '../EmailsClicks.vue';

    export default {
        name: 'InformacionTab',
        props: {
            subscriptor: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false
            };
        },
        methods: {
            getIcon(evento) {
                switch (evento) {
                    case 'abierto':
                        return 'fa fa-envelope-open';
                    case 'clickado':
                        return 'fa fa-mouse-pointer';
                    case 'enviado':
                        return 'fa fa-paper-plane';
                    default:
                        return '';
                }
            },
            getMessage(evento) {
                switch (evento.tipo_actividad) {
                    case 'abierto':
                        return `Ha abierto el boletín <b><a href="/boletines/${evento.comunicado.id}" target="_blank">${evento.comunicado.asunto}</a></b>.`;
                    case 'clickado':
                        return `Ha hecho clic en el <b><a href="/boletines/${evento.comunicado.id}" target="_blank">${evento.comunicado.asunto}</a></b>.`;
                    case 'enviado':
                        return `Se ha enviado el boletín <b><a href="/boletines/${evento.comunicado.id}" target="_blank">${evento.comunicado.asunto}</a></b>.`;
                    default:
                        return '';
                }
            },
            getTitle(evento) {
                switch (evento) {
                    case 'abierto':
                        return 'Ha abierto el email';
                    case 'clickado':
                        return 'Clic';
                    case 'enviado':
                        return 'Email enviado';
                    default:
                        return '';
                }
            }
        },
        components: {
            EmailsEnviados, TimeLineComponent, EmailsVisualizaciones, EmailsClicks
        }
    }
</script>